module.exports = __webpack_public_path__ + "img/two-btn-right.24fddbad.svg";